import { render, staticRenderFns } from "./BhpForm.vue?vue&type=template&id=5af11f4c&"
import script from "./BhpForm.vue?vue&type=script&lang=js&"
export * from "./BhpForm.vue?vue&type=script&lang=js&"
import style0 from "./BhpForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports